<template>
    <v-card class="model-chart-component-wrapper">
        <v-row>
            <v-col cols="3">
                <div class="model-selection">
                    <v-btn v-for="(model, index) in loadedModels" :key="index" @click="selectModel(index)" rounded="lg" variant="outlined">
                        Modell {{ index + 1 }}
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-card-text>
            <div class="slot-chart-wrapper">
                <apexchart type="line" :options="lineChartOptions" :series="lineSeries" height="400"></apexchart>
            </div>
            <v-divider></v-divider>
            <div class="slot-chart-wrapper">
                <apexchart type="bar" :options="barChartOptions" :series="barSeries" height="400"></apexchart>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts';
import { mapState } from 'vuex';

export default {
    components: {
        apexchart: VueApexCharts
    },
    data() {
        return {
            selectedModel: {
                steps: [],
                totalCustomers: 0,
                totalCost: 0
            },
            lineChartOptions: {
                chart: {
                    type: 'line'
                },
                xaxis: {
                    categories: []
                },
                title: {
                    text: 'Total Cost per Step'
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " €";
                        }
                    }
                }
            },
            lineSeries: [{
                name: 'Total Cost',
                data: []
            }],
            barChartOptions: {
                chart: {
                    type: 'bar'
                },
                xaxis: {
                    categories: []
                },
                title: {
                    text: 'Customers per Step'
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " Kunden";
                        }
                    }
                }
            },
            barSeries: [{
                name: 'Customers',
                data: []
            }]
        };
    },
    computed: {
        ...mapState('marketing', ['loadedModels'])
    },
    methods: {
        updateChart(model) {
            if (model && model.steps) {
                const formattedCategories = model.steps.map(step => `(${step.start}-${step.end})`);

                this.lineChartOptions.xaxis.categories = formattedCategories;
                this.lineSeries[0].data = model.steps.map(step => step.totalCost);

                this.barChartOptions.xaxis.categories = formattedCategories;
                this.barSeries[0].data = model.steps.map(step => step.customers);
            }
        },
        selectModel(index) {
            this.selectedModel = JSON.parse(JSON.stringify(this.loadedModels[index]));
            this.updateChart(this.selectedModel);
        }
    }
};
</script>

<style scoped>
.slot-chart-wrapper {
    margin: 24px 0;
    padding: 0 24px;
}

.model-selection {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 12px;
    max-height: 160px;
    overflow-y: auto;
}

.model-chart-component-wrapper {
    padding: 24px;
    border: 1px solid #ccc;
    border-radius: 12px;
}
</style>